import { Injectable } from '@angular/core';

import { ObjectCheckerService } from '../../../../services/object-checker.service';
import { EventLogService, Actions } from '../../../../services/eventLog';
import { AwningService } from '../../../../services/awning/awning.service';

@Injectable()
export class AwningDeleteHandler {
  name: string;

  constructor(
    protected objectCheckerSrvc: ObjectCheckerService,
    private eventLog: EventLogService,
    private awningService: AwningService
  ) {
    this.name = 'awningDeleteControls';
  }

  async invoke(awining, buttonName: 'left' | 'base' | 'right') {
    let toRemove: any;

    switch (buttonName) {
      case 'left': {
        const lastInRow = this.awningService.getExtensions(awining).filter(aw => this.awningService.isLastInRow(aw));
        toRemove = lastInRow.find(aw => {
          const { awningType } = aw.userData.entity;
          return this.awningService.getAwningPositionType(awningType) === 'left';
        });
        break;
      }
      case 'base': {
        toRemove = awining;
        break;
      }
      case 'right': {
        const lastInRow = this.awningService.getExtensions(awining).filter(aw => this.awningService.isLastInRow(aw));
        toRemove = lastInRow.find(aw => {
          const { awningType } = aw.userData.entity;
          return this.awningService.getAwningPositionType(awningType) === 'right';
        });
        break;
      }
    }
    this.eventLog.dispatch(new Actions.ObjectDeleteAction(toRemove));

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectControls/Handlers/AwningDeleteHandler.ts